import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { axiosInstance } from '../../utils/axios';
import {
  createPartnerFailure,
  createPartnerRequest,
  createPartnerSuccess,
  editPartnerFailure,
  editPartnerRequest,
  editPartnerSuccess,
  fetchPartnerById,
  fetchPartnerByIdFailure,
  fetchPartnerByIdSuccess,
  fetchPartnersFailure,
  fetchPartnersRequest,
  fetchPartnersSuccess,
} from './partnerSlice';

function* fetchPartnersSaga(action) {
  try {
    const { search_by, search_key, page, limit } = action.payload;
    const params = {
      page,
      limit,
      search_by,
      search_key,
    };
    const response = yield call(axiosInstance.get, '/users', { params });
    yield put(fetchPartnersSuccess(response.data));
  } catch (error) {
    yield put(fetchPartnersFailure(error.message));
  }
}

function* fetchPartnerByIdSaga(action) {
  try {
    const response = yield call(axiosInstance.get, `/users/${action.payload}`);
    yield put(fetchPartnerByIdSuccess(response.data));
  } catch (error) {
    yield put(fetchPartnerByIdFailure(error.message));
  }
}

function* editPartnerRequestSaga(action) {
  try {
    const { _id, __v, createdAt, updatedAt, ...sanitizedPayload } = action.payload;
    const response = yield call(axiosInstance.put, `/users/${_id}`, sanitizedPayload);
    yield put(editPartnerSuccess(response.data));
  } catch (error) {
    yield put(editPartnerFailure(error.response.data.error));
  }
}

function* createPartnerSaga(action) {
  try {
    const response = yield call(axiosInstance.post, '/users', action.payload);
    yield put(createPartnerSuccess(response.data));
  } catch (error) {
    yield put(createPartnerFailure(error.response.data.errors));
  }
}

function* partnerSaga() {
  yield takeLatest(fetchPartnersRequest.type, fetchPartnersSaga);
  yield takeEvery(fetchPartnerById.type, fetchPartnerByIdSaga);
  yield takeLatest(createPartnerRequest.type, createPartnerSaga);
  yield takeLatest(editPartnerRequest.type, editPartnerRequestSaga);
}

export default partnerSaga;
